<template>
  <SharedError
    :description="description || $i18n.t('common.errors.404.description')"
    :title="title || $i18n.t('common.errors.404.title')"
    :url="url || '/'"
  />
</template>
<script lang="ts" setup>
interface Props {
  description?: string;
  title?: string;
  url?: string;
}
const { $i18n } = useNuxtApp();

const props = withDefaults(defineProps<Props>(), {
  description: undefined,
  title: undefined,
  url: undefined,
});

const { description, title } = toRefs(props);
</script>
